








































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { ApiV2Service } from '@/services/api.base.service';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component({
  components: {
  },
})
export default class AdminSettings extends Vue {

  private disableConsumerExport: boolean = false;
  private streamEnabled: boolean = true;
  private disableMessageBtn: boolean = false;

  public async mounted() {
    try {
      const { state } = await ApiV2Service.get<{ state: string }>('admin/streamState');
      if (state === 'unknown') {
        this.disableMessageBtn = true;
      } else {
        this.streamEnabled = state === 'enabled';
      }
    } catch (e: any) {
      this.disableMessageBtn = true;
    }
  }

  private async runQuicksightExport() {
    await ApiV2Service.post('reporting/quicksight/export', {});
  }

  private async runConsumerExport() {
    await ApiV2Service.post<any>('admin/export', {});
    this.disableConsumerExport = true;
    setTimeout(() => {
      this.disableConsumerExport = false;
    }, 5000);
  }

  private async toggleStreamState() {
    this.disableMessageBtn = true;

    const confirmMessage = this.streamEnabled ?
      'This will stop all inbound messages for all customers from being processed.\n\nThis is a Very Important Operation. If you are not sure what this entails, you should cancel this operation\n\nAre you sure?'
      : 'This will allow messages into the system for all customers. Are you sure?';

    if (confirm(confirmMessage)) {
      this.streamEnabled = !this.streamEnabled;
      await ApiV2Service.post('admin/streamState', { state: this.streamEnabled ? 'enabled' : 'disabled'});
    }

    this.disableMessageBtn = false;
  }
}
